<template>
    <div v-if="roomPartition">
        <TopBar :title="roomPartition.nameShort" :breadcrumbs="locationBreadcrumbs(roomPartition)" transparent />
        <LocationUpdateForm :location="roomPartition" :location-types="roomPartitionTypes" />
    </div>
</template>

<script setup lang="ts">
import TopBar from '@/components/TopBar.vue';
import { GetRoomPartitionForEditDocument } from '@/generated/graphql';
import LocationUpdateForm from '@/location/forms/LocationUpdateForm.vue';
import { locationBreadcrumbs } from '@/location/locationBreadcrumbs';
import { useResult } from '@/utils/graphql';
import { useQuery } from '@vue/apollo-composable';

const props = defineProps<{ partitionId: string }>();

const query = useQuery(GetRoomPartitionForEditDocument, { id: props.partitionId });
const roomPartition = useResult(query.result, undefined, (x) => x.roomPartition);
const roomPartitionTypes = useResult(query.result, [], (x) => x.roomPartitionTypes.nodes);
</script>
